<template>
    <main class="tw-flex tw-min-h-screen tw-flex-col md:tw-flex-row">
        <div 
            v-if="isSidebarCollapsed === false && isMobileMenuOpen"
            class="md:tw-hidden tw-fixed tw-inset-0 tw-bg-black/50 tw-z-[999]"
            @click="toggleSidebar"
        />
        
        <SideBar :is-collapsed="isSidebarCollapsed" :is-mobile="isMobile" />
        
        <div class="tw-flex tw-flex-col tw-flex-1" :class="['pagev2', { active: isSidebarCollapsed }, { 'md:tw-ml-72': !isSidebarCollapsed && !isMobile }, { 'md:tw-ml-24': isSidebarCollapsed && !isMobile }]">
            <NavBar />
            <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-flex-1 tw-overflow-y-auto">
                <slot></slot>
            </div>
            <FooTer />
        </div>
    </main>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ref, onMounted, onUnmounted } from 'vue';
import FooTer from "../../ui/v2/FooTer.vue";
import NavBar from "../../ui/v2/NavBar.vue";
import SideBar from "../../ui/v2/SideBar.vue";

export default {
    name: "MainLayout",
    components: {
        SideBar,
        NavBar,
        FooTer,
    },
    setup() {
        const isMobile = ref(false);
        const isMobileMenuOpen = ref(false);

        const checkMobile = () => {
            isMobile.value = window.innerWidth < 768;
        };

        onMounted(() => {
            checkMobile();
            window.addEventListener('resize', checkMobile);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', checkMobile);
        });

        return {
            isMobile,
            isMobileMenuOpen
        };
    },
    computed: {
        ...mapState('ui', ['isSidebarCollapsed']),
        ...mapState({
            theme: state => state.ui.theme,
        }),
        
    },
    methods: {
        ...mapActions('ui', ['toggleSidebar']),
    }
};
</script>
<style scoped>main {
    width: 100%;
    overflow-x: hidden;
}

.pagev2 {
    min-height: 100vh;
    padding-bottom: 0;
    width: 100%;
    flex: 1 1 auto;
}

@media (max-width: 767px) {
    .pagev2 {
        margin-left: 0;
        width: 100%;
        padding-top: 50px;
    }
}

@media (min-width: 768px) {
    .pagev2 {
        width: calc(100% - 288px);
    }

    .pagev2.active {
        width: calc(100% - 96px);
    }
}
</style>
